module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_SteveWilhite_Still.619edfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_SteveWilhite_Still.jpg
// module id = d2At
// module chunks = 0